import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical, Users, Route, Handshake, ArrowRight } from "lucide-react";
import { ecosystem } from "../mock/pages";
import { institutions } from "../mock/mock";
import { SectionHeading } from "./SectionHeading";

const icons = { FlaskConical, Users, Route, Handshake };

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="relative overflow-hidden py-24 lg:py-32" style={{ background: "var(--sand)" }}>
      <div className="mx-auto max-w-[1280px] px-5 lg:px-6">
        <SectionHeading
          eyebrow="Built over 50 years"
          title="A learning ecosystem, not a new school"
          sub={ecosystem.intro}
        />

        <div className="mt-16 grid gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
          {/* Timeline */}
          <div className="relative" data-reveal="">
            <span
              className="absolute bottom-2 left-[7px] top-2 w-[2px]"
              style={{ background: "linear-gradient(to bottom, var(--gold-400), rgba(192,138,46,.15))" }}
            />
            {ecosystem.milestones.map((m, i) => (
              <div key={m.year} className="relative pb-9 pl-9" data-reveal="" style={{ transitionDelay: `${i * 80}ms` }}>
                <span
                  className="absolute left-0 top-1.5 h-4 w-4 rounded-full"
                  style={{ background: "var(--sand)", border: "2px solid var(--gold)" }}
                />
                <p className="eyebrow" style={{ color: "var(--gold)" }}>
                  {m.year}
                </p>
                <h3 className="font-display mt-2 text-[1.25rem]" style={{ color: "var(--teal-900)" }}>
                  {m.title}
                </h3>
                <p className="mt-2 max-w-[520px] text-[0.9rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                  {m.text}
                </p>
              </div>
            ))}
          </div>

          {/* What it means for the school */}
          <div data-reveal="" style={{ transitionDelay: "120ms" }}>
            <h3 className="font-display text-[1.6rem] leading-snug" style={{ color: "var(--teal-900)" }}>
              What five decades of institution building gives a six-year-old
            </h3>

            <div className="mt-8 space-y-4">
              {ecosystem.advantages.map((a) => {
                const Icon = icons[a.icon];
                return (
                  <div
                    key={a.title}
                    className="flex gap-4 rounded-2xl bg-white p-6"
                    style={{ border: "1px solid rgba(11,59,54,.08)", transition: "box-shadow .3s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 26px 50px -36px rgba(8,46,41,.5)")}
                    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
                  >
                    <span
                      className="grid h-11 w-11 shrink-0 place-items-center rounded-xl"
                      style={{ background: "var(--teal-100)", color: "var(--teal-700)" }}
                    >
                      <Icon size={19} strokeWidth={1.7} />
                    </span>
                    <div>
                      <h4 className="font-display text-[1.05rem]" style={{ color: "var(--teal-900)" }}>
                        {a.title}
                      </h4>
                      <p className="mt-1.5 text-[0.86rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                        {a.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              {institutions.map((i) => (
                <a
                  key={i.short}
                  href={i.url}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full px-5 py-2.5 text-[0.8rem] font-semibold"
                  style={{
                    border: "1px solid rgba(11,59,54,.18)",
                    color: "var(--teal-800)",
                    transition: "background .3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,.8)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  {i.short}
                </a>
              ))}
              <Link
                to="/campus"
                className="group flex items-center gap-2 rounded-full px-5 py-2.5 text-[0.8rem] font-semibold"
                style={{ background: "var(--teal-800)", color: "#FBF7F0" }}
              >
                See the campus
                <ArrowRight size={14} className="group-hover:translate-x-1" style={{ transition: "transform .3s ease" }} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
